import React, { useEffect, useState } from 'react';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const principios = [
  {
    id: 6,
    color: '#621132',
    title: "Principio 6. - Definir Objetivos y Tolerancias al Riesgo.",
    items: [
      "Misión y Visión",
      "Plan Institucional de Desarrollo.",
      "Programa Operativo Anual.",
      "Proceso de Administración de Riesgos.",
      "Presupuestación, programación, distribución y asignación de los recursos con base en los objetivos establecidos por cada Unidad Administrativa.",
      "Mecanismos de difusión de los objetivos estratégicos y especificos."
    ]
  },
  {
    id: 7,
    color: '#9e2348',
    title: "Principio 7. - Identificar, Analizar y Responder a los Riesgos.",
    items: [
      "Metodología para la Administración de Riesgos",
      "Programa de Trabajo de Administración de Riesgos (PTAR).",
      "Establecimiento de Estrategias para Disminuir los Riesgos.",
      "Enlace de Administración de Riesgos.",
      "Riesgos idenficiados que puedan afectar el cumplimiento de los objetivos y metas institucionales.",
      "Evaluación de Riesgos que puedan afectar el cumplimiento de los objetivos y metas institucionales."
    ]
  },
  {
    id: 8,
    color: '#a98188',
    title: "Principio 8. - Considerar el Riesgo de Corrupción.",
    items: [
      "Identificación y Determinación de Posibles Riesgos de Corrupción.",
      "Establecimiento de Controles Oportunos"
    ]
  },
  {
    id: 9,
    color: '#94824d',
    title: "Principio 9. - Identificar, Analizar y Responder al Cambio.",
    items: [
      "Planes de Sucesión",
      "Disposiciones y el Manual Administrativo de Aplicación General en Materia de Control Interno",
      "Identificación y Análisis a los cambios que impactan a las condiciones internas."
    ]
  }
];

const AdministracionRiesgos = () => {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const toggleAccordion = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <>
      <HeaderSCI title="COMPONENTES DEL CONTROL INTERNO" />

      <div className="container ci-nav pt-4">
        {/* Title pill */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-5 d-flex justify-content-center">
            <div className="ci-nav__btn--pill" style={{ cursor: 'default', margin: 0 }}>
              Administración de Riesgos
            </div>
          </div>
        </div>

        {/* Text Description */}
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-10">
            <p className="ci-desc-text">
              Es el proceso que evalúa los riesgos a los que se enfrenta la institución en la procuración del cumplimiento de sus objetivos. Esta evaluación provee las bases para identificar los riesgos, analizarlos, catalogarlos, priorizarlos y desarrollar respuestas que mitiguen su impacto en caso de materialización, incluyendo los riesgos de corrupción.
            </p>
          </div>
        </div>

        {/* Accordion / Toggle List */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            {principios.map((prin) => {


              const isExpanded = expandedId === prin.id;

              return (
                <div key={prin.id} className="mb-2">
                  {/* Header Button */}
                  <div 
                    className="ci-nav__btn ci-nav__btn--doc" 
                    onClick={() => toggleAccordion(prin.id)}
                    style={{ cursor: 'pointer', padding: '8px 12px' }}
                  >
                    <div className="ci-nav__icon" style={{ backgroundColor: prin.color }}>
                      <i className="fa-solid fa-id-card"></i>
                    </div>
                    <span className="ci-nav__label ci-nav__label--doc" style={{ fontSize: '1rem', color: '#621132' }}>
                      {prin.title}
                    </span>
                  </div>

                  {/* Expanded Content */}
                  <div className={`ci-accordion-wrapper ${isExpanded ? 'is-open' : ''}`}>
                    <div className="ci-accordion-inner">
                      {prin.items.length > 0 ? (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <ul style={{ color: prin.color, fontSize: '0.95rem', fontStyle: 'italic', lineHeight: '1.6' }}>
                            {prin.items.map((item, idx) => (
                              <li key={idx} className="mb-2">
                                <a href="#" style={{ color: '#621132' }}>{item}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <p style={{ color: '#621132', fontSize: '0.95rem', fontStyle: 'italic' }}>
                            No hay documentos disponibles.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdministracionRiesgos;
